export const base = '/orders';
export const ordersList = `${base}`;
export const orderById = (id: string) => `${base}/${id}`;

export const orderByIdAfterCreation = (id: string) => `${base}/${id}?${afterCreationQueryParam}=true`;
export const afterCreationQueryParam = 'redirectedAfterCreation';
